// extracted by mini-css-extract-plugin
export default {"stateTableCell":"ItR01FZQ","modalCopy":"ugOTHAQk"};